import { IBusiness } from '@trii/types/dist/Contacts/contacts';

/**
 * Type guard to check if an object is an IBusiness
 * @param obj The object to check
 * @returns True if the object is an IBusiness
 */
export function isBusiness(obj: any): obj is IBusiness {
  if (obj?.isBusiness === true) {
    // Si se ha marcado explícitamente como negocio con la propiedad isBusiness
    return true;
  }
  
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof obj.id === 'string' &&
    typeof obj.spaceId === 'string' &&
    typeof obj.name === 'string' &&
    Array.isArray(obj.membersId) &&
    Array.isArray(obj.members) &&
    Array.isArray(obj.phones) &&
    Array.isArray(obj.emails) &&
    typeof obj.imageUrl === 'string' &&
    !('firstName' in obj) &&
    !('lastName' in obj)
  );
}
